module.exports = __webpack_public_path__ + "img/icon-more.ef96a798.png";